import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoIcon } from "../../../../components/ui/icons";
import { useSpinner } from "../../../../customHooks";
import useNotification from "../../../../components/notification/useNotification";
import { useDispatch, useSelector } from "react-redux";
import { downloadDeviceReport } from "./deviceUpdateReportExportSlice";
import { AppDispatch } from "../../../../store";
import {selector as deviceUpdateReportSelector} from "./deviceUpdateReportExportSlice";
import { DEFAULT_REPORT_DOWNLOAD_MESSAGE } from "../../../../common/constants";

function DeviceUpdateReportExportCSV({ orgId, updateStatus, isFirmware,deviceCount }) {
  const dispatch = useDispatch<AppDispatch>();
  const deviceUpdateReport = useSelector(deviceUpdateReportSelector);
  const {showSuccessNotification, showWarningNotification } = useNotification();
  useSpinner(deviceUpdateReport.status);
  const downloadCSV = async () => {
    if (deviceCount === 0) return;
    try {
       const resultAction: any = await dispatch(
        downloadDeviceReport({ orgId, updateStatus, isFirmware })
      );

      if (downloadDeviceReport.fulfilled.match(resultAction)) {
        const { data, headers } = resultAction.payload;
      const disposition = headers["content-disposition"];
      let filename = "report.csv";

      if (disposition && disposition.indexOf("filename=") !== -1) {
        filename = disposition.split("filename=")[1].replace(/"/g, "");
      }

      const downloadUrl = window.URL.createObjectURL(data);
      const blobFileAnchorTabRef = document.createElement("a");
      blobFileAnchorTabRef.href = downloadUrl;
      blobFileAnchorTabRef.download = filename;
      document.body.appendChild(blobFileAnchorTabRef );
      blobFileAnchorTabRef.click();
      blobFileAnchorTabRef.remove();
      URL.revokeObjectURL(downloadUrl);
      showSuccessNotification(data.message || DEFAULT_REPORT_DOWNLOAD_MESSAGE.SUCCESS);
    } else {
      showWarningNotification(resultAction.payload?.data?.error?.message ||
        resultAction.payload?.data?.message || resultAction.payload?.message ||
        DEFAULT_REPORT_DOWNLOAD_MESSAGE.FAILED);
    }
    } catch (error) {
      console.error(error);
      showWarningNotification(error.message || DEFAULT_REPORT_DOWNLOAD_MESSAGE.FAILED);
    }
  };
  const tooltipLabel =
    deviceCount === 0 ? "No device data" : "Export CSV";
   const iconStyle: React.CSSProperties = deviceCount === 0
  ? { cursor: "not-allowed", opacity: 0.4 }
  : { cursor: "pointer", color: "#0d6efd" };



  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-top">{tooltipLabel}</Tooltip>}
    >
      <span
        style={iconStyle}
        onClick={downloadCSV}
      >
        <InfoIcon />
      </span>
    </OverlayTrigger>
  );
}

export default DeviceUpdateReportExportCSV;
